import Alpine from 'alpinejs';

import {
    deleteFile,
    getUploadParams,
    uploadFile,
} from '../../../../utils/application-files.js';

const ApplicationFileUploadControl = ({ applicationId, group, name }) => ({
    name,
    docs: [],
    nextId: 1,

    init() {
        this.handleSubmit = this.handleSubmit.bind(this);

        this.addMiddleware(this.handleSubmit);
    },
    destroy() {
        this.removeMiddleware(this.handleSubmit);
    },

    onAddClick(event) {
        if (this.isSubmitting) {
            event.preventDefault();
            event.stopPropagation();
        }
    },
    onFileInputChange() {
        const file = this.$refs.fileInput.files[0];

        this.$refs.fileInput.value = null;

        if (!file || this.isSubmitting) {
            return;
        }

        this.addFile(file);
    },

    async addFile(file) {
        const id = this.nextId;
        this.nextId += 1;

        try {
            const params = await getUploadParams(applicationId, group, file);

            const { key } = params;

            const abortController = new AbortController();

            const newDoc = {
                id,
                file,
                key,
                params,
                abortController,
                isDone: false,
                progress: 0,
            };

            this.setDocs([...this.docs, newDoc]);
        } catch (err) {
            alert(err.message);

            this.deleteDoc(id);
        }
    },

    async deleteDoc(id) {
        const doc = this.docs.find((f) => f.id === id);

        if (!doc) {
            return;
        }

        try {
            doc.abortController.abort();

            this.setDocs(this.docs.filter((f) => f.id !== id));

            await deleteFile(doc.key);
        } catch (err) {
            alert(err.mesage);
        }
    },

    updateDoc(id, nextProps) {
        this.setDocs(
            this.docs.map((file) => {
                if (file.id !== id) {
                    return file;
                }

                return {
                    ...file,
                    ...nextProps,
                };
            }),
        );
    },

    setDocs(docs) {
        this.docs = docs;

        this.$nextTick(() => {
            this.form.touch(name);
            docs.forEach((_, i) => {
                this.form.touch(`${name}.${i}`);
            });
            this.form.validate();
        });
    },

    async handleSubmit() {
        for (const doc of this.docs) {
            if (doc.isDone) {
                continue;
            }

            const { id, file, params, abortController } = doc;

            try {
                await uploadFile({
                    file,
                    params,
                    abortSignal: abortController.signal,
                    onProgress: (progress) => {
                        this.updateDoc(id, {
                            progress,
                        });
                    },
                });
            } catch (err) {
                this.updateDoc(id, {
                    isDone: false,
                    progress: 0,
                });

                throw err;
            }

            this.updateDoc(id, {
                isDone: true,
                progress: 0,
            });
        }
    },
});

Alpine.data(
    'app_view_components_applications_ApplicationFileUploadControl',
    ApplicationFileUploadControl,
);
